/* eslint-disable no-var */
import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { PosModel, PosDataBySessionModel, PosTransactionsReturn } from './PosModels';
import type { APIResponse } from '@store/Shared/shared';

export const addPos = createAsyncThunk('Pos/AddPos', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post('Pos/AddPos', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updatePos = createAsyncThunk('Pos/AddPos', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post('Pos/UpdatePos', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getPosList = createAsyncThunk(
  'Pos/GetPosList',
  async (personId?: string, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      var url = personId ? `Pos/GetPosList?PersonId=${personId}` : 'Pos/GetPosList';

      const { data } = await ntxAPI.get(url);
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPosLookupList = createAsyncThunk(
  'Pos/getPosLookupList',
  async (_, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      const { data } = await ntxAPI.get('Pos/GetPosLookupList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPosByDeviceId = createAsyncThunk(
  'Pos/getPosByDeviceId',
  async (deviceId?: string, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      var url = `Pos/GetPosByDeviceId?DeviceId=${deviceId}`;

      const { data } = await ntxAPI.get(url);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetPosById = createAsyncThunk('Pos/GetPosById', async (id: string, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get(`Pos/GetPosById?Id=${id}`);
    if (data?.succeeded) {
      //===
      return data.data;
    } else {
      return rejectWithValue(data.message);
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getPosDataBySessionId = createAsyncThunk(
  'Pos/getPosDataBySessionId',
  async (sessionId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Pos/GetPosDataBySessionId?sessionId=${sessionId}`);
      if (data?.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPosTransactionsDetailsByCode = createAsyncThunk(
  'Pos/getPosTransactionsDetailsByCode',
  async (code: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<PosTransactionsReturn>>(
        `Pos/GetPosTransactionsDetailsByCode?Code=${code}`
      );
      if (data) {
        return data;
      } else {
        return rejectWithValue('error');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsOrderSalsePOSList = createAsyncThunk(
  'Pos/getTransactionsOrderSalsePOSList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<any>>(`Pos/GetTransactionsOrderSalsePOSList`);
      if (data) {
        return data;
      } else {
        return rejectWithValue('error');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetPOSTransactionsReturnsList = createAsyncThunk(
  'Pos/GetPOSTransactionsReturnsList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<any>>(`SalesReturns/GetPOSTransactionsReturnsList`);
      if (data) {
        return data;
      } else {
        return rejectWithValue('error');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsOrderSalsePOSById = createAsyncThunk(
  'Pos/getTransactionsOrderSalsePOSById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<any>>(`Pos/GetTransactionsOrderSalsePOSById?Id=${id}`);
      if (data) {
        return data;
      } else {
        return rejectWithValue('error');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUnRegistrationPos = createAsyncThunk(
  'Pos/getUnRegistrationPos',
  async (_, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      var url = 'Pos/GetUnRegistrationPos';

      const { data } = await ntxAPI.get(url);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  PosList: PosModel[];
  PosLookupList: PosModel[];
  PosById: PosModel;
  PosDataBySession: PosDataBySessionModel;
  loading: boolean;
  error: any | null;
  //
  loading2: boolean;
  error2: any | null;
} = {
  PosList: [],
  PosLookupList: [],
  PosById: {} as PosModel,
  PosDataBySession: {} as PosDataBySessionModel,
  loading: false,
  error: null,
  //
  loading2: false,
  error2: null
};

const PosSlice = createSlice({
  name: 'Pos',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPosList.pending, state => {
        state.loading = true;
      })
      .addCase(getPosList.fulfilled, (state, action: PayloadAction<PosModel[]>) => {
        state.loading = false;
        state.PosList = action.payload;
      })
      .addCase(getPosList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(getPosLookupList.pending, state => {
        state.loading = true;
      })
      .addCase(getPosLookupList.fulfilled, (state, action: PayloadAction<PosModel[]>) => {
        state.loading = false;
        state.PosLookupList = action.payload;
      })
      .addCase(getPosLookupList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //

      .addCase(GetPosById.pending, state => {
        state.loading = true;
      })
      .addCase(GetPosById.fulfilled, (state, action: PayloadAction<PosModel>) => {
        state.loading = false;
        state.PosById = action.payload;
      })
      .addCase(GetPosById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //

      .addCase(getPosDataBySessionId.pending, state => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(getPosDataBySessionId.fulfilled, (state, action: PayloadAction<PosDataBySessionModel>) => {
        state.loading2 = false;
        state.PosDataBySession = action.payload;
      })
      .addCase(getPosDataBySessionId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
    //
  }
});

export default PosSlice.reducer;
